import Msie from '../../msie/index'

export default class Area {
  constructor(el, props) {
    this.el = el

    if (!this.el.length) {
      return false
    }
    this.section = this.el.attr('id').replace('Sektion', '')
    this.shape = this.el[0].nodeName
    this.available = false
    this.title = this.el.attr('title')
    this.props = props
    this.isIe = new Msie().checkUserAgent()
    this.isMac = this._isMac();
  }

  validShape() {
    return (
      this.shape === 'polygon' || this.shape === 'rect' || this.shape == 'path'
    )
  }

  draw() {
    this.el.removeClass('available disabled');
    let css = this.available ? 'available' : 'disabled'
    this.el.addClass('section').addClass(css)
  }

  enableClick(cb) {        
      if (this.available) {
          this.el.on('click touchend', e => {
              e.stopPropagation()
              e.preventDefault()
              e.stopImmediatePropagation()              
              cb(this.section)
          })
      }
  }

  _isMac() {
    window.navigator.userAgent.indexOf("Safari") > -1;
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
      return ua.indexOf('chrome') == -1;
    }
  }

  _getPoints(scale) {
    if (this.shape === 'path') {
      return this._getPathPoints(scale)
    }
    let coords = ''
    // Check if the browser is IE or Edge or Safari(mac) and set coords accordingly
    if (this.isIe || this.isMac) {
      coords = this.el[0].getAttribute('points').split(' ')
    }
    else {
      coords = this.el.get(0).points
    }
    let points = []
    for (var i = 0; i < coords.length; i++) {
      let point = coords[i]
      if (this.isIe || this.isMac) {
        const temp = point.split(',')
        if (temp.length < 2) {
          if (i % 2 == 1) {
            points.push({
              x: coords[i - 1] * scale,
              y: coords[i] * scale
            });
          }
        } else if (!isNaN(temp[0]) && !isNaN(temp[1])) {
          points.push({
            x: temp[0] * scale,
            y: temp[1] * scale
          });
        }
      } else {
        points.push({
          x: point.x * scale,
          y: point.y * scale
        })
      }
    }

    return points
  }

  _getPathPoints(scale) {
    let rect = this.el[0].getBoundingClientRect()
    let xMin = Math.round(rect.x * scale)
    let xMax = Math.round((rect.x + rect.width) * scale)
    let yMin = Math.round(rect.y * scale)
    let yMax = Math.round((rect.y + rect.height) * scale)

    return [{ x: xMin, y: yMin }, { x: xMax, y: yMax }]
  }

  _getRectPoints(svg) {
    let parentPos = $(svg)[0].getBoundingClientRect(),
      childrenPos = this.el[0].getBoundingClientRect(),
      relativePos = {}

    ;(relativePos.top = childrenPos.top - parentPos.top),
      (relativePos.right = childrenPos.right - parentPos.right),
      (relativePos.bottom = childrenPos.bottom - parentPos.bottom),
      (relativePos.left = childrenPos.left - parentPos.left)

    let xMax = Math.round(relativePos.left + childrenPos.width)
    let yMax = Math.round(relativePos.top + childrenPos.height)

    return {
      x: Math.round((xMax + relativePos.left) * 0.5),
      y: Math.round((yMax + relativePos.top) * 0.5)
    }
  }

  getCenter(scale, svg) {    
    if (this.shape == 'path' || this.shape === 'rect') {
      return this._getRectPoints(svg)
    }

    let region = new Region(this._getPoints(scale))
    return region.centroid()
  }
}

class Point {
  constructor(x, y) {
    this.x = x
    this.y = y
  }
}

class Region {
  constructor(points) {
    this.points = points || []
    this.length = points.length
  }

  area() {
    let area = 0,
      i,
      j,
      point1,
      point2

    for (i = 0, j = this.length - 1; i < this.length; j = i, i++) {
      point1 = this.points[i]
      point2 = this.points[j]
      area += point1.x * point2.y
      area -= point1.y * point2.x
    }
    area /= 2

    return area
  }

  centroid() {
    let x = 0,
      y = 0,
      i,
      j,
      f,
      point1,
      point2

    for (i = 0, j = this.length - 1; i < this.length; j = i, i++) {
      point1 = this.points[i]
      point2 = this.points[j]
      f = point1.x * point2.y - point2.x * point1.y
      x += (point1.x + point2.x) * f
      y += (point1.y + point2.y) * f
    }

    f = this.area() * 6

    return new Point(x / f, y / f)
  }
}
